import { useEffect, useState } from 'react';

import { Card } from '../../components/Card';
import classes from './SoundSelection.module.css';
import { Text } from '../../components/Text';
import AudioPlayer from '../../audio/audioPlayer';
import TimerProgressBar from '../../components/timerProgressBar/TimerProgressBar';
import { PlayButtonIcon, PauseButtonIcon } from '../../assets/icons';

const SoundSelection = () => {
    const audioPlayer = AudioPlayer('/assets/audios/volume-sample.mp3');
    const [audioDuration, setAudioDuration] = useState(0);
    /**
     * Exact duration of the volume-sample.mp3 audio file is 4 seconds,
     * If volume-sample.mp3 audio file changes, must need to update the below
     * audioEndTimeDuration with actual duration of that audio file.
     */
    const [audioEndTimeDuration, setAudioEndTimeDuration] = useState(4);

    useEffect(() => {
        let aDuration = audioPlayer?.audioRoundedDuration();
        if (aDuration !== 0) {
            setAudioEndTimeDuration(aDuration);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [audioPlayer?.audioRoundedDuration]);

    const playAudioAsync = () => {
        if (!audioPlayer.isPlaying) {
            setAudioDuration(0);
            setTimeout(() => {
                setAudioDuration(audioEndTimeDuration);
                audioPlayer.playAudio();
            }, 1000);
        }
    };

    const Icon = !audioPlayer.isPlaying ? PlayButtonIcon : PauseButtonIcon;

    return (
        <Card className={classes.container}>
            <p>
                <Text text="Put on your headphones and play the audio below." variant="body" />
            </p>
            <div className={classes.audioPlayer}>
                <TimerProgressBar
                    className={classes.audioDuration}
                    timerBarDuration={audioDuration}
                    showTime={true}
                    endTime={audioEndTimeDuration}
                />
                <button className={classes.playerBtn} onClick={playAudioAsync} disabled={audioPlayer.isPlaying} data-testid="play-image">
                    <Icon className={classes.btnIcon} />
                </button>
            </div>
            <p>
                <Text
                    text="Adjust the volume on your device until you can hear clearly."
                    variant="body"
                />
            </p>
            <p>
                <Text
                    text="When you are happy with the sound, click <b>Next</b> to proceed."
                    variant="body"
                />
            </p>
        </Card>
    );
};

export default SoundSelection;
